/**
 * Interface que define a estrutura de dados para as funcionalidades/tema da empresa.
 */
export interface ICompanyFeaturesModel {
    onScreenName?: string;
    primaryColor: string;
    secondaryColor: string;
    logo?: string;
    secondaryLogo?: string;
    organizationDepth: number;
}

/**
 * Classe que implementa e gerencia os dados de funcionalidades/tema da empresa.
 */
export class CompanyFeaturesModel implements ICompanyFeaturesModel {
    onScreenName?: string;
    primaryColor: string;
    secondaryColor: string;
    logo?: string;
    secondaryLogo?: string;
    organizationDepth: number;

    constructor(data: Partial<ICompanyFeaturesModel>) {
        this.onScreenName = data?.onScreenName;
        this.primaryColor = data?.primaryColor ?? '#FFFFFF';
        this.secondaryColor = data?.secondaryColor ?? '#000000';
        this.logo = data?.logo;
        this.secondaryLogo = data?.secondaryLogo;
        this.organizationDepth = data.organizationDepth ?? 0;
    }
}